import React from "react";

function WhyChooseUs() {
  return (
    <section className="why">
      <h2>Why Choose Us?</h2>

      <div className="why-grid">
        <div className="card">
          <h3>The Talent-First Approach</h3>
          <p>
            We source professionals with the technical skills and mindset
            to excel in a remote-first world.
          </p>
        </div>

        <div className="card">
          <h3>Operational Simplicity</h3>
          <p>
            We take the administrative weight off your shoulders—managing
            EPF/ETF, taxes, and HR.
          </p>
        </div>

        <div className="card">
          <h3>Long-Term Stability</h3>
          <p>
            We prioritize continuity with a structured partnership model
            designed for reliable growth.
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;